import React from "react";

export default function StoryIQSection() {
  return (
    <section className="flex flex-col md:flex-row items-center justify-between max-w-4xl mx-auto gap-10">
      {/* LEFT TEXT SECTION */}
      <div className="flex flex-col self-start md:self-auto">
        <div className="font-bebas font-normal tracking-wider text-[30px] lg:text-[50px] leading-[130%] text-[#06382f] mb-6">
          <span className="text-[#0E8A43]">StoryIQ</span> — <br />
          <span>Context That Clicks</span>
        </div>

        <ul className="text-[#004D4D] text-base lg:text-lg font-inter font-medium leading-[130%] space-y-6 pl-5 list-disc mb-6">
          <li>Quick Summary, Visual Stories, Interactive Prompts</li>
          <li>Publisher Archive revivals</li>
          <li>Social Share ready output</li>
        </ul>

        <div className="text-[#004D4D] text-lg md:text-[20px] font-medium font-inter">
          Every article becomes a new path to more content, more value.
        </div>
      </div>

      {/* RIGHT VIDEO SECTION */}
      <div className="w-full max-w-[350px]">
        <video
          src="./storyIQ.mov"
          controls
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-auto object-cover"
        />
      </div>
    </section>
  );
}
